import React from 'react'
import Gallerypage from '../components/Gallery'
import Footer from '../components/footer'
import Navbar from '../components/Navbar'
const Gallery = () => {
  return (
    <>
      <Navbar/>
      <Gallerypage />
      <Footer />
    </>
  )
}

export default Gallery
